import { AbstractControl, ValidatorFn } from "@angular/forms";
import { isAddress } from "viem";

export function walletAddressValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return null; // allow empty, required validation handled separately
      return isAddress(value) ? null : { invalidAddress: true };
    };
  }
  